import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Separator } from 'telia-front-react';
import UnsettledReceivablesStore from '../../../stores/UnsettledReceivablesStore';
import AllPaidNotice from './AllPaidNotice';
import DebtNotices from './DebtNotices';

interface IBalanceNotices {
  unsettledReceivablesStore?: UnsettledReceivablesStore;
}

@inject('unsettledReceivablesStore')
@observer
export default class BalanceNotices extends React.Component<IBalanceNotices> {
  public render(): JSX.Element {
    const { unsettledReceivablesStore } = this.props;

    if (!unsettledReceivablesStore.unsettledReceivables.isFinished) {
      return null;
    }

    if (unsettledReceivablesStore.hasDebt) {
      return (
        <>
          <DebtNotices />
          <Separator color="invisible" spacing="xxsmall" />
        </>
      );
    }

    if (unsettledReceivablesStore.allInvoicesPaid) {
      return (
        <>
          <AllPaidNotice />
          <Separator color="invisible" spacing="xxsmall" />
        </>
      );
    }

    return null;
  }
}
